module["exports"] = [
  "San",
  "Borgo",
  "Sesto",
  "Quarto",
  "Settimo"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/it/address/city_prefix.js
// module id = 1426
// module chunks = 1